import { ApplicationClientIdentifier } from '@front-app/services/EventsApi/EventDataModel';
import { sortAlphabeticalDesc } from '@front-app/util/sort';
import { EventDataColumn } from '../Model';

export const sortEventBannerReportHeaders = (a: EventDataColumn, b: EventDataColumn): number => {
	// Items without groups go at the start
	const groupSort = eventGroupSort(a.columnData.groupId, b.columnData.groupId);
	if (groupSort !== 0) {
		return groupSort;
	}
	// If they are the same, group-wise, then sub-sort by
	// clientIdentifier
	const clientIdSort = clientIdentifierSort(a.columnData.clientIdentifier, b.columnData.clientIdentifier);
	if (clientIdSort !== 0) {
		return clientIdSort;
	}
	// The client ID is also the same, then we will subsort by location
	return sortAlphabeticalDesc(a.columnData.location, b.columnData.location);
};

function eventGroupSort(groupA?: string, groupB?: string) {
	if (groupA && !groupB) {
		return 1;
	}
	if (!groupA && groupB) {
		return -1;
	}
	// Two items with groups should sort by groupId
	if (groupA !== groupB && groupA && groupB) {
		return sortAlphabeticalDesc(groupA, groupB);
	}
	return 0;
}

const BROWSER_IDENTIFIERS = [
	ApplicationClientIdentifier.PHOENIX,
	ApplicationClientIdentifier.TRAPP,
];

function clientIdentifierSort(a: ApplicationClientIdentifier, b: ApplicationClientIdentifier) {
	const aIsBrowser = BROWSER_IDENTIFIERS.includes(a);
	const bIsBrowser = BROWSER_IDENTIFIERS.includes(b);
	if (aIsBrowser === bIsBrowser) {
		return 0;
	}
	return aIsBrowser ? -1 : 1;
}
